var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBackWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.995 11.0041H5.40501L8.70501 7.71409C8.89332 7.52579 8.9991 7.27039 8.9991 7.00409C8.9991 6.73779 8.89332 6.4824 8.70501 6.29409C8.51671 6.10579 8.26132 6 7.99501 6C7.72871 6 7.47332 6.10579 7.28501 6.29409L2.28501 11.2941C2.19397 11.3892 2.12261 11.5013 2.07501 11.6241C1.975 11.8676 1.975 12.1406 2.07501 12.3841C2.12261 12.5068 2.19397 12.619 2.28501 12.7141L7.28501 17.7141C7.37798 17.8078 7.48858 17.8822 7.61044 17.933C7.7323 17.9838 7.863 18.0099 7.99501 18.0099C8.12703 18.0099 8.25773 17.9838 8.37959 17.933C8.50145 17.8822 8.61205 17.8078 8.70501 17.7141C8.79874 17.6211 8.87314 17.5105 8.9239 17.3887C8.97467 17.2668 9.00081 17.1361 9.00081 17.0041C9.00081 16.8721 8.97467 16.7414 8.9239 16.6195C8.87314 16.4977 8.79874 16.3871 8.70501 16.2941L5.40501 13.0041H20.995C21.2602 13.0041 21.5146 12.8987 21.7021 12.7112C21.8897 12.5237 21.995 12.2693 21.995 12.0041C21.995 11.7389 21.8897 11.4845 21.7021 11.297C21.5146 11.1094 21.2602 11.0041 20.995 11.0041Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackWhite);
export default __webpack_public_path__ + "static/media/arrowBack-white.5e4bce6ab45d556988332c3a2644d15e.svg";
export { ForwardRef as ReactComponent };